<template>
  <div>
    <div class="row preview">
      <div v-for="designId in designIdList"
      v-bind:key="designId"
      class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
        <a
          v-on:click="clickLink(designId)">
          <img
            v-bind:src="app_root + '/assets/common/img/fun/designpaper/thumnails/' + designId + '.png'"
            class="thumnail-image"
          />
        </a>
      </div>
    </div>
    <!--<div class="row message">
      <span class="col-xs-12">&uarr;
          <LabelFunMessage fcontId="0" msgkey="101" />
      </span>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { CONTENTS_INFO } from "@/common/contentsinfo";
//import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "DesignPaperTilesNonMessage",
  props: {
    designIdList: Array,
  },
  /*components: {
    LabelFunMessage,
  },*/
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    ...mapState(["os","lg2"]),
    ...mapGetters(["isWwTemplate"]),
    fcontid: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1)
    },
    usedMediaSize: function () {
      return CONTENTS_INFO[this.fcontid].media_size;
    },
    usedMediaType: function () {
      return CONTENTS_INFO[this.fcontid].media_type;
    }
  },
  methods: {
    clickLink: function (designID) {
      const param = {
        articleIdToSamplePage: this.fcontid,
        mediaSize: this.usedMediaSize,
        mediaType: this.usedMediaType
      }
      this.$store.commit('setDesignPaperParameters', param)
      
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "designpaper_thumbnail",
        "custom_parameter2": designID
      })

      this.$router.push({ 
        path: '/' + this.lg2 + '/designpaper/' + designID,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.message {
  font-size: 18px;
}

@media (max-width: 480px) {
  .message {
    font-size: 16px;
  }
}
</style>